<template>
  <div class="top-pick-skeleton">
    <div v-for="i in 4" :key="'pick-' + i" class="pick-card">
      <ion-skeleton-text animated class="image"></ion-skeleton-text>

      <div class="content">
        <ion-skeleton-text animated class="name"></ion-skeleton-text>
        <div class="footer">
          <ion-skeleton-text animated class="price"></ion-skeleton-text>
          <ion-skeleton-text animated class="btn"></ion-skeleton-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IonSkeletonText } from "@ionic/vue";

export default {
  name: "TopPickSkeleton",
  components: { IonSkeletonText }
};
</script>

<style scoped>
/* ===== TOP PICKS ===== */
.top-pick-skeleton {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 8px 0;
}

.top-pick-skeleton::-webkit-scrollbar {
  display: none;
}

.pick-card {
  min-width: 140px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.image {
  width: 100%;
  height: 100px;
}

.content {
  padding: 10px;
}

.name {
  width: 90%;
  height: 14px;
  border-radius: 6px;
  margin-bottom: 8px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  width: 60%;
  height: 14px;
  border-radius: 6px;
}

.btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}
</style>
